import React from 'react';
import Social from '../Social/Social';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import { portfolioWorks as worksArr } from './../../App';
import Project from '../Project';

const Home: React.FC = ({ t }: any) => {
  let lastWorksArr = new Array();

  for (let i = 0; i < 4; i++) {
    lastWorksArr.push(worksArr[i]);
  }

  const portfolioWorks = lastWorksArr.map((item, index) => <Project key={index} {...item} />);

  return (
    <>
      <div className="circle" />
      <div className="about">
        <div className="about__header">
          <h2 className="about__title title title-big">Front-end developer</h2>
          <h4 className="about__desrc title">Fedorchenko Dmytro</h4>
          <div className="about__img">
            <img src="./img/me.png" alt="project img" />
          </div>
        </div>

        <div className="container">
          <div className="about__info">
            <Social />

            <div id={'about'}>
              <h3>{t('about_me_title')}</h3>
              <div className="text">
                <p>
                  {t('about_me_text1')} <span>{t('about_technologies')} </span>
                  {t('about_me_text2')}
                </p>
              </div>
            </div>

            <div className="projects">
              <h3>{t('portfolio_main_title')}</h3>

              <div className="projects__wrap">{portfolioWorks}</div>

              <div className="projects__bttn-wrap">
                <Link className="projects-bttn bttn" to="/projects">
                  {t('look_more')}
                </Link>
              </div>
            </div>

            <div>
              <h3>{t('dev_title')}</h3>
              <div className="text">
                <p
                  dangerouslySetInnerHTML={{
                    __html: t('dev_p1', { interpolation: { escapeValue: false } }),
                  }}></p>
                <p>{t('dev_p2')}</p>
                <p>{t('dev_p3')}</p>
              </div>
            </div>

            <div>
              <h3>{t('dev_way_title')}</h3>
              <div className="text">
                <p>{t('dev_way_p')}</p>
              </div>
            </div>

            <Social />

            <div>
              <h3>{t('process_title')}</h3>
              <ul className="text">
                <li>{t('process_text1')}</li>
                <li>{t('process_text2')}</li>
                <li>{t('process_text3')}</li>
                <li>{t('process_text4')}</li>
                <li>{t('process_text5')}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withNamespaces()(Home);
